module.exports = __webpack_public_path__ + "img/skiing003.0d2805e3.jpg";